import { styled } from "@mui/material/styles";
import ListItemButton from "@mui/material/ListItemButton";

// Estilizando o ListItemButton
const StyledListItemButton = styled(ListItemButton)({
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  border: "1px solid #ddd", // Borda entre os botões
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  transition: "all 0.2s ease-in-out",
  marginBottom: "4px",
  marginTop: "4px",
  width: "100%", 
  minHeight: "56px",
  padding: "12px 16px", 
  display: "flex", 
  alignItems: "center", 
  justifyContent: "flex-start", 
  textOverflow: "ellipsis", 
  overflow: "hidden",
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "#f0f0f0",
    boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.2)",
    transform: "translateY(-2px)",
  },
  "&:active": {
    boxShadow: "0px 3px 4px rgba(0, 0, 0, 0.2)",
    transform: "translateY(1px)",
  },
});

export default StyledListItemButton;
